import React, { useEffect, useState } from 'react';
import './footer.css'; // Optional: for custom styling
import footerIcon from '../../image/footerImage2.jpg';

const Footer = () => {
  return (
    <footer className="footer">
      <div 
        className="footer-background"
        style={{
          backgroundImage: `url(${footerIcon})`,
          backgroundRepeat: 'repeat-x',
          backgroundSize: `auto 150px`,
          height: '150px',
          width: '100%'
        }}
      />
    </footer>
  );
};

export default Footer;